@import '../../../theme.scss';

verdocs-field-initial {
  font-family: $verdocs-primary-font;
  width: 83px;
  height: 36px;
  display: block;
  font-size: 11px;
  position: relative;
  letter-spacing: 0.3px;
  scroll-margin: 20px 0;
  transform-origin: bottom left;
  border-radius: var(--verdocs-field-radius);
  background-color: var(--verdocs-field-background, transparent);
  border: var(--verdocs-field-border, 1px solid rgba(0, 0, 0, 0.2));
  // Host is focusable via tabindex; hide any browser-rendered text caret and use a pointer cursor
  // so it doesn't look like an editable text area.
  cursor: pointer;
  caret-color: transparent;

  label {
    top: -14px;
    left: -1px;
    height: 14px;
    color: var(--verdocs-field-text-color, white);
    padding: 0 4px;
    font-size: 9px;
    line-height: 13px;
    position: absolute;
    background: #4a4a99;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }

  &.done {
    border: none;
    opacity: 1;
  }

  // When the Edit/Clear dropdown is open, raise this field above its siblings so
  // the menu isn't clipped by neighboring fields.
  &.menu-open {
    z-index: 50;
  }

  .initial-container {
    width: 100%;
    height: 100%;
    position: relative;

    img {
      display: block;
      height: 100%;
      width: auto;
      max-width: none;
      max-height: none;
    }

    .action-menu {
      position: absolute;
      top: calc(100% + 4px);
      left: 0;
      min-width: 90px;
      background: #ffffff;
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 1000;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      font-size: 12px;
      font-family: $verdocs-primary-font;

      .menu-item {
        background: #ffffff;
        border: none;
        padding: 8px 12px;
        color: #333333;
        cursor: pointer;
        text-align: left;
        width: 100%;
        font-size: 12px;
        line-height: 1.2;
        height: auto;
        font-family: inherit;

        &:hover {
          background-color: #f0f0f0;
          color: #000000;
        }

        &:not(:last-child) {
          border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        }
      }
    }
  }

  &.disabled .initial-container {
    opacity: 0.5;
    pointer-events: none;
  }

  button {
    // This is needed to bring down the cursor from the parent element, which is where interactjs applies it
    cursor: inherit;

    box-sizing: border-box;
    border: none;
    color: var(--verdocs-field-text-color, rgba(0, 0, 0, 0.87));
    font-weight: 500;
    transform-origin: 0 0;
    height: 100%;
    width: 100%;
    background: none;
    font-size: 11px;

    &.hide {
      display: none;
    }
  }

  &.required {
    border: 1px solid var(--verdocs-required-field-border);
  }

  &.filled {
    border: none !important;
    background-color: transparent !important;
  }

  verdocs-button-panel {
    top: -3px;
    left: -2px;
    opacity: 0.5;
    z-index: 1000;
    cursor: pointer;
    position: absolute;
    transform: scale(0.6);

    &[data-active],
    &:hover {
      opacity: 1;
    }

    .icon {
      svg {
        fill: #333333;
      }

      &:hover {
        svg {
          fill: #000000;
        }
      }
    }
  }

  .settings-icon {
    position: absolute;
    top: -3px;
    left: -20px;
    display: inline-block;
    cursor: pointer;
    opacity: 0.3;

    svg {
      fill: $border-color;
    }

    &:hover {
      opacity: 1;
    }
  }

  .edge-top,
  .edge-right,
  .edge-left,
  .edge-bottom {
    position: absolute;
    z-index: 10;
  }

  .edge-top {
    top: -2px;
    left: 0;
    right: 0;
    height: 5px;
  }

  .edge-right {
    top: 0;
    bottom: 0;
    right: -2px;
    width: 5px;
  }

  .edge-left {
    top: 0;
    left: -2px;
    bottom: 0;
    width: 5px;
  }

  .edge-bottom {
    bottom: -2px;
    left: 0;
    right: 0;
    height: 5px;
  }
}
